import React, { Component } from "react";
import Datas from "../../data/facilities/lab.json";

import { Container, Row, Col } from "react-bootstrap";

import { Styles } from "./styles/events.js";

import { BreadcrumbBox } from "../../components/common/Breadcrumb.js";

import HeaderTwo from "../../components/HeaderTwo.js";
import FooterTwo from "../../components/FooterTwo.js";
import PopularLab from "../../components/facilities/PopularLab.js";

class Lab extends Component {
  render() {
    return (
      <Styles>
        {/* Main Wrapper */}
        <div className="main-wrapper event-details-page">
          {/* Header 2 */}
          <HeaderTwo />

          {/* Breadcrumb */}
          <BreadcrumbBox title="Science Lab" />

          {/* Library Details Area */}
          <section className="event-details-area">
            <Container>
              <Row>
                <Col lg="9" md="8" sm="12">
                  <div className="event-details-content">
                    <div className="heading">
                      <h4>Advanced Science Lab for Practical Learning</h4>
                    </div>
                    <div className="event-icon">
                      <ul className="list-unstyled list-inline">
                        <li className="list-inline-item">
                          <i className="las la-flask"></i> Modern Lab Equipment
                        </li>
                        <li className="list-inline-item">
                          <i className="las la-microscope"></i> Hands-on
                          Experiments
                        </li>
                        <li className="list-inline-item">
                          <i className="las la-shield-alt"></i> Safety &
                          Guidelines
                        </li>
                      </ul>
                    </div>
                    <div className="event-details-banner">
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          `/assets/images/phy5.jpg`
                        }
                        alt="Library"
                        className="img-fluid"
                      />
                    </div>
                    <div className="event-details-overview">
                      <h5>Science Lab Overview</h5>
                      <p>
                        The science lab is a center for hands-on learning,
                        equipped with modern tools and technology to support
                        experiments in Physics, Chemistry, and Biology. It
                        provides microscopes, chemical apparatus, and digital
                        measuring instruments to encourage practical exploration
                        and scientific discovery. With a strong focus on safety,
                        the lab follows strict guidelines and provides
                        protective gear to ensure a secure environment. Guided
                        by experienced teachers, students engage in interactive
                        experiments, research projects, and STEM activities,
                        fostering critical thinking and a deeper understanding
                        of scientific concepts.
                      </p>
                      <ul className="list-unstyled">
                        <li>
                          <i className="fa fa-check"></i>
                          <span>
                            Equipped with state-of-the-art laboratory
                            instruments and cutting-edge technology, the lab
                            provides students with the necessary tools to
                            conduct precise scientific research, hands-on
                            experiments.
                          </span>
                        </li>
                        <li>
                          <i className="fa fa-check"></i>
                          <span>
                            The lab features well-structured workstations that
                            allow students to engage in independent and
                            collaborative experiments, fostering analytical
                            thinking, problem-solving skills.
                          </span>
                        </li>

                        <li>
                          <i className="fa fa-check"></i>
                          <span>
                            Guided by experienced faculty and lab instructors,
                            students receive hands-on training in experimental
                            techniques, laboratory safety protocols, and
                            scientific methodologies, helping them develop the
                            essential skills needed.
                          </span>
                        </li>
                      </ul>
                    </div>

                    <div className="event-details-speaker">
                      <h5>Science Lab Facilities</h5>
                      <Row>
                        {Datas.map((data, i) => (
                          <Col lg="3" md="6" sm="6" key={i}>
                            <div className="event-speaker-item">
                              <img
                                src={
                                  process.env.PUBLIC_URL +
                                  `/assets/images/${data.personImage}`
                                }
                                alt=""
                                className="img-fluid"
                              />
                            </div>
                          </Col>
                        ))}
                      </Row>
                    </div>
                    <div className="event-details-overview">
                      {/* <h5>Library Committee</h5> */}
                      {/* <p>
                        Our library is a knowledge hub with an extensive
                        collection of books, research materials, and digital
                        resources. It provides an ideal environment for students
                        to study, explore ideas, and enhance learning across
                        diverse subjects like literature, history, science, and
                        technology.Equipped with modern facilities, including
                        high-speed internet, digital archives, and multimedia
                        resources, students can access a wealth of information.
                      </p> */}
                      {/* <div>
      <ul className="list-unstyled">
        <li>
          <i className="fa">1</i>
          <span className="font-weight-bold"> Dr. Arun Kumar </span>
          <br />
          <span>Chairman</span>
        </li>
      </ul>

      <ul className="list-unstyled">
        <li>
          <i className="fa">2</i>
          <span> Dr. Priya Sharma </span>
        </li>
      </ul>

      <ul className="list-unstyled">
        <li>
          <i className="fa">3</i>
          <span> Mr. Rajesh Verma </span>
        </li>
      </ul>

      <ul className="list-unstyled">
        <li>
          <i className="fa">4</i>
          <span> Ms. Anjali Nair </span>
        </li>
      </ul>
    </div> */}
                    </div>
                  </div>
                </Col>

                <Col lg="3" md="4" sm="12">
                  <div className="event-details-sidebar">
                    <Row>
                      <Col md="12">
                        <div className="event-sidebar-info">
                          <ul className="list-unstyled event-info-list">
                            <li>
                              Facilities: <span>Well-equipped stations.</span>
                            </li>
                            <li>
                              Supervision: <span>Expert guidance.</span>
                            </li>
                            <li>
                              Learning: <span>Hands-on.</span>
                            </li>

                            <li>
                              Innovation: <span>Creative experiments.</span>
                            </li>
                            <li>
                              Collaboration: <span>Team projects.</span>
                            </li>
                          </ul>
                        </div>
                      </Col>
                      <Col md="12">
                        <PopularLab />
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>

          {/* Footer 2 */}
          <FooterTwo />
        </div>
      </Styles>
    );
  }
}

export default Lab;
